import React, { useEffect, useState } from 'react';
import { useFlags, withLDProvider } from 'launchdarkly-react-client-sdk';
import { I18nextProvider } from 'react-i18next';

import { OptinProps } from 'types/types';
import i18next from './i18n/index';
import { OptIn } from './containers';

let LDUser = window.location.origin;

export const getLDRelayURL = (hostname: string) => {
  let env = '';
  const smilesDomain = hostname.indexOf('smiles.com.br') > -1;
  const rx = smilesDomain ? /^(.*)\.smiles\.com\.br/g : /^(.*)\.voebiz\.com\.br/g;
  const res = rx.exec(hostname);
  if (res !== null) {
    if (res.length > 1 && res[1] && res[1].length > 3) {
      env = res[1];
    }
    env = env.replace(/portal|voebiz/g, '').replace('uat', 'hml');
  }

  if (hostname === 'localhost') {
    env = '-hml5';
    LDUser = 'https://voebiz-uat5.smiles.com.br';
  }

  return `https://ldrelay${env}.smiles.com.br`;
};

const clientSideId = '62baf3989195871574e35e6c';
const launchDarklyURL = getLDRelayURL(window.location.hostname);

const App = ({ promoId, promoContent, promoRule, promoLink }: OptinProps) => {
  const [loading, setLoading] = useState(true);
  const { apiDomain } = useFlags();

  useEffect(() => {
    if (apiDomain) {
      setLoading(false);
    }
  }, [apiDomain]);

  if (loading) {
    return <div />;
  }

  return (
    <div className="vbz-lf">
      <I18nextProvider i18n={i18next}>
        <OptIn promoId={promoId} promoContent={promoContent} promoRule={promoRule} promoLink={promoLink} />
      </I18nextProvider>
    </div>
  );
};

export default withLDProvider<OptinProps>({
  clientSideID: clientSideId,
  user: { key: LDUser },
  reactOptions: {
    useCamelCaseFlagKeys: false,
  },
  options: {
    baseUrl: launchDarklyURL,
  },
})(App);
